<template>
	<editor
		:show.sync="editorVisible"
		:title="title"
		:alert-info="alertInfo"
		:data-model-name="editorDataModel"
		:record-id="recordId"
		:fields="editorFields"
		:handler-url="handlerUrl"
		@change="doChange"
		:check-ever-edited="false"
		v-if="editorVisible"
	></editor>
</template>

<script>
export default {
	data() {
		return {
			editorDataModel: "Order",
			editorFields: [
				{
					name: "customer",
					isOnlyShow: true,
					params: {
						nameFields: ["name","type"]
					},
					col: 6
				},
				{
					name: "express_type",
					isOnlyShow: true,
					col: 6
				},
				{
					name: "address",
					isOnlyShow: true,
					params: {
						nameFields: ["name"]
					},
					col: 6
				},
				{
					name: "total_price",
					isOnlyShow: true,
					col: 6
				},
				{
					name: "pay_method",
					col: 6,
					params:{
						showEnums:['1','10','11','20','21','30','40','50']
					}
				},
				{
					name: "desc",
					col: 6
				},
				{
					name: "primary_img",
					col: 6
				}
			]
		};
	},
	computed: {
		editorVisible: {
			get: function() {
				return this.show;
			},
			set: function(val) {
				this.$emit("update:show", val);
			}
		},
		title() {
			if (this.isIncome) {
				return "确认已经收到款项, 是否继续?";
			} else {
				return "确认已经完成退款, 是否继续? ";
			}
		},
		alertInfo() {
			if (this.isIncome) {
				return "如果选择用户余额支付，将检查用户余额是否足够并直接扣费";
			} else {
				return "如果实际并未发生付款退款行为，请直接删除订单，无需退款";
			}
		},
		handlerUrl() {
			if (this.isIncome) {
				return "orderm/do_has_payed/";
			} else {
				return "orderm/do_return_payed/";
			}
		}
	},
	props: {
		show: {
			type: Boolean,
			default: false
		},
		recordId: {
			type: String,
			default: ""
		},
		isIncome: {
			type: Boolean,
			default: true
		}
	},
	methods: {
		doChange(val) {
			this.$emit("change", val);
		}
	}
};
</script>